module.exports = __webpack_public_path__ + "img/box.9dc476e1.svg";